import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { post, del } from '../../utils/api';
import useApi from '../../hooks/useApi';
import Form from '../common/Form';
//
// Компонент выводит список стикеров экспонента для редактирования
//
const ExhibitorEditStickers = () => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const navigate = useNavigate();
    // const auth = useSelector(state => state.auth);
    const exhibitor = useSelector(state => state.exhibitor);
    const [ stickers, setStickers ] = useState([]);
    const [ isChanging, setIsChanging ] = useState(false);
    // eslint-disable-next-line
    const [ params, setParams ] = useState({ event: exhibitor.event._id });
    const [ data, error, isLoading ] = useApi({ type: 'get', method: '/stickers/', params });

    // Разбираем список стикеров и отмечаем какие выбраныs
    useEffect(() => {
        if(!exhibitor || !data) return;
        const stickers = [];
        data.stickers.forEach(item => {
            if(exhibitor.stickers.find(s => s._id === item._id)) {
                item.checked = true;
            } else {
                item.checked = false;
            }
            item.status = ''; // для отметки результата запроса
            stickers.push(item);
        });
        setStickers(stickers);
    }, [exhibitor, data]);

    // Внесение/удаление стикера в список экспонента
    const onChange = async (sticker) => {
        if(isChanging) return;
        
        setIsChanging(true);
        sticker.status = <small className='success'> - {t('common.loading')}</small>;

        let result;
        if(sticker.checked) {
            result = await del('/s2e/', { sticker: sticker._id, exhibitor: exhibitor._id });
        } else {
            result = await post('/s2e/', { sticker: sticker._id, exhibitor: exhibitor._id });
        }

        if(result.error) {
            sticker.status = <small className='error'> - {t(result.error)}</small>;
        } else {
            sticker.status = <small className='success'> - {t('common.noerror')}</small>;
            sticker.checked = !sticker.checked;
        }
        setIsChanging(false);
    };

    return (
    <div>
        <h1>{t('exhibitoredit.title_stickers')}</h1>
        {error && <div className='error'>{t(error)}</div>}
        {isLoading ? <span>{t('common.loading')}</span> :
        <React.Fragment>
            {stickers.length < 1 ? <p>{t('exhibitoredit.nostickers')}</p> :
            <Form>
                <fieldset>
                {stickers.map(item => (
                <div key={item._id} className='Form-row'>
                    <input
                        id={item._id}
                        type='checkbox'
                        checked={item.checked}
                        onChange={e => onChange(item)}
                    />
                    <label htmlFor={item._id}>
                        <span
                            className='sticker'
                            style={{ color: item.color, background: item.background }}
                        >
                            {item.text[lang]}
                        </span>
                        {item.status}
                    </label>
                </div>
                ))}
                </fieldset>
            </Form>}

            <Form>
                <input
                    type='submit'
                    value={t('exhibitoredit.back2')}
                    onClick={() => navigate('/cabinet/exhibitorview/' + exhibitor._id)}
                />
            </Form>
        </React.Fragment>}
    </div>
	);
};

export default ExhibitorEditStickers;
